// vimeo video

var hero_video =  document.getElementById('hero-video');

if (typeof(hero_video) != 'undefined' && hero_video != null) {
  var videoPlayer = new Vimeo.Player('hero-video');
}
